/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationTreeNodeDto } from './OrganizationTreeNodeDto';
import {
    OrganizationTreeNodeDtoFromJSON,
    OrganizationTreeNodeDtoFromJSONTyped,
    OrganizationTreeNodeDtoToJSON,
    OrganizationTreeNodeDtoToJSONTyped,
} from './OrganizationTreeNodeDto';

/**
 * 
 * @export
 * @interface FindOrganizationTreeDto
 */
export interface FindOrganizationTreeDto {
    /**
     * 
     * @type {OrganizationTreeNodeDto}
     * @memberof FindOrganizationTreeDto
     */
    root: OrganizationTreeNodeDto;
}

/**
 * Check if a given object implements the FindOrganizationTreeDto interface.
 */
export function instanceOfFindOrganizationTreeDto(value: object): value is FindOrganizationTreeDto {
    if (!('root' in value) || value['root'] === undefined) return false;
    return true;
}

export function FindOrganizationTreeDtoFromJSON(json: any): FindOrganizationTreeDto {
    return FindOrganizationTreeDtoFromJSONTyped(json, false);
}

export function FindOrganizationTreeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOrganizationTreeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'root': OrganizationTreeNodeDtoFromJSON(json['root']),
    };
}

export function FindOrganizationTreeDtoToJSON(json: any): FindOrganizationTreeDto {
    return FindOrganizationTreeDtoToJSONTyped(json, false);
}

export function FindOrganizationTreeDtoToJSONTyped(value?: FindOrganizationTreeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'root': OrganizationTreeNodeDtoToJSON(value['root']),
    };
}

